import { Log } from '../../shared/log';
const log = new Log('ReminderService');
import * as _ from 'underscore';
import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { AppConfig } from '../../app.config';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {UserService} from '../../services/user/user.service';
import {SafeDrivingService} from '../../widgets/templateDrivenWidget/services/safe-driving.service';
import {RegoReminderItem} from '../dataObject/RegoReminderItem';
import {SafeDriveReminderItem} from '../dataObject/SafeDriveReminderItem';

@Injectable()
export class ReminderService {
  private serverUrl;
  private dismissReminderUrl;

  constructor(
    private authHttp: AuthHttp,
    private appConfig: AppConfig,
    private safeDriving: SafeDrivingService,
    private userService: UserService
  ) {
    this.serverUrl = appConfig.getValue('endPoint');
    this.dismissReminderUrl = this.serverUrl + 'dismissreminder';
  }

  isDismissed(item, dismissedList): boolean {
    return _.contains(dismissedList, item.dismissId);
  }

  dismissReminder(reminderId): Promise<Object> {
    const params = {
      'reminderId': reminderId
    };

    return this.authHttp.put(this.dismissReminderUrl, params)
      .toPromise()
      .then(response => {
        return response;
      }).catch(this.handleError);
  }

  getDismissedReminders(): Promise<Object> {
    return this.authHttp.get(this.dismissReminderUrl)
      .toPromise()
      .then(response => {
        return response.json();
      }).catch(this.handleError);
  }

  private handleError(error: any) {
    log.error(error);
    return Promise.reject(error);
  }

  fetchSafeDriveReminder(): Promise<SafeDriveReminderItem> {
    return this.safeDriving.getSafeDrivingExpiry().then((safeDrivingExpireDate) => {
      if (safeDrivingExpireDate !== '') {
        const safeDriveItem = new SafeDriveReminderItem(safeDrivingExpireDate, this.safeDriving);
        return Promise.resolve(safeDriveItem);
      } else {
        return Promise.resolve(null);
      }
    }).catch(this.handleError);
  }

  fetchRegoReminder(): Promise<Array<RegoReminderItem>> {
    return this.userService.getVehicleRegistrationDetails()
      .then((vehicleRegistrationDetails) => {
        const items = [];
        vehicleRegistrationDetails.forEach((regoDetail) => {
          if (regoDetail.status !== 'CURRENT') {
            const regoItem = new RegoReminderItem(regoDetail);
            items.push(regoItem);
          }
        });

        return Promise.resolve(items);
      }).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./app/reminder/service/reminder.service.ts